import { useEffect, useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { Logo } from '@/components/Logo'
import { Icon } from '@/components/Icon'
import { ENV, ENV_LABEL } from '@/config/env'

const NAV_LINKS = [
  { to: '/', label: '首页' },
  { to: '/services', label: '核心服务' },
  { to: '/about', label: '关于我们' },
]

export function Navbar() {
  const [scrolled, setScrolled] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)
  const location = useLocation()

  // 滚动时添加阴影背景
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  // 路由变化时关闭移动端菜单
  useEffect(() => {
    setMenuOpen(false)
  }, [location.pathname])

  // 锁定移动端菜单时页面滚动
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : ''
    return () => {
      document.body.style.overflow = ''
    }
  }, [menuOpen])

  return (
    <header className={`navbar ${scrolled ? 'is-scrolled' : ''}`}>
      <div className="navbar-inner container">
        <Logo />

        <nav className="navbar-links" aria-label="主导航">
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) => `navbar-link ${isActive ? 'is-active' : ''}`}
              end={link.to === '/'}
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="navbar-actions">
          {ENV.mode !== 'prod' && (
            <span className={`env-badge env-${ENV.mode}`}>{ENV_LABEL[ENV.mode] || ENV.mode}</span>
          )}
          <button
            className="navbar-toggle"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label={menuOpen ? '关闭菜单' : '打开菜单'}
            aria-expanded={menuOpen}
          >
            <Icon name={menuOpen ? 'close' : 'menu'} size={26} />
          </button>
        </div>
      </div>

      {/* 移动端菜单 */}
      <div className={`navbar-mobile ${menuOpen ? 'is-open' : ''}`}>
        <nav className="navbar-mobile-links" aria-label="移动端导航">
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) => `navbar-mobile-link ${isActive ? 'is-active' : ''}`}
              end={link.to === '/'}
            >
              {link.label}
              <Icon name="arrow" size={18} />
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
  )
}
